import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Loginservices } from '../login/login.services';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-resetpage',
  templateUrl: './resetpage.component.html',
  styleUrls: ['./resetpage.component.css']
})
export class ResetpageComponent {
    resetForm: FormGroup;
    routId=0
  ruleList = [
    { key: 'lower', label: 'A lowercase letter', check: false },
    { key: 'upper', label: 'A capital (uppercase) letter', check: false },
    { key: 'number', label: 'A number', check: false },
    { key: 'special', label: 'A special character', check: false },
    { key: 'min', label: 'Minimum 8 characters', check: false },
    { key: 'confirmpswd', label: 'Confirm password matched', check: false }
  ];

  constructor(private fb: FormBuilder,private loginservice:Loginservices,private route:ActivatedRoute,
    private router: Router,private spinner:NgxSpinnerService) {
   
     this.route.queryParams.subscribe(params => {
    const id = params['id'];
    this.routId=id;
    this.varifylink(id);
      });
    this.resetForm = this.fb.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });
  }

  checkPasswordStrength() {
    const pass = this.resetForm.get('password')?.value || '';

    this.ruleList.find(r => r.key === 'lower')!.check = /[a-z]/.test(pass);
    this.ruleList.find(r => r.key === 'upper')!.check = /[A-Z]/.test(pass);
    this.ruleList.find(r => r.key === 'number')!.check = /\d/.test(pass);
    this.ruleList.find(r => r.key === 'special')!.check = /[@$!%*?&^#]/.test(pass);
    this.ruleList.find(r => r.key === 'min')!.check = pass.length >= 8;

  }
 checkconfirmPassword() {
  const pw = this.resetForm.get('password')?.value || '';
  const cpw = this.resetForm.get('confirmPassword')?.value || '';

  const confirmRule = this.ruleList.find(r => r.key === 'confirmpswd');
  

  if (!cpw) {
    confirmRule!.check = false;
    return;
  }

  confirmRule!.check = pw === cpw;
}

  allRulesPassed(): boolean {
    return this.ruleList.every(rule => rule.check);
  }

  onSubmit() {
    const p = this.resetForm.get('password')?.value;
    const cp = this.resetForm.get('confirmPassword')?.value;

    if (p !== cp) {
      Swal.fire('Passwords do not match', '', 'error');
      return;
    }

    if (this.allRulesPassed()) {
      const payload={
        "resetid":this.routId,
          newpassword:this.resetForm.value.password,

      }
      this.spinner.show();
      this.loginservice.resetpassword(payload).subscribe(res=>{
        this.spinner.hide();
        if(res.response=='error' && res.message=='passwordmatched'){
              Swal.fire({
                    icon: "error",
                    title: "New password should be other than your last three passwords...",
              })
             }
             else{
         Swal.fire('Password Reset Successfully!', '', 'success').then(()=>{
          this.router.navigate(['/login']);
         });
        }
      // this.resetForm.reset();
      this.ruleList.forEach(r => r.check = false);

      })
     
    }
  }

  varifylink(id){
    const payload={
      id:id,
    }
   this.loginservice.verifylink(payload).subscribe(res=>{
    if(res.response!=='success'){
        Swal.fire("This link has been expired or You have already used this Link", "Please click on 'RESET PASSWORD' link again to get a new link to change password", "warning").then(()=>{
          this.router.navigate(['/login']);

        })
      
    }
   })
  }


}
